export default "__VITE_ASSET__4e9bc024__"